var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.577,
    height: 24.168,
    viewBox: "0 0 23.577 24.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell",
    transform: "translate(-1794.9 -1551.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    "data-name": "Caminho 582",
    d: "M14.1,27.563a2.486,2.486,0,0,0,2.479-2.479H11.623A2.478,2.478,0,0,0,14.1,27.563Z",
    transform: "translate(1790.2 1548.436)",
    fill: "#a5b9d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_87",
    "data-name": "Subtra\\xE7\\xE3o 87",
    d: "M24649.727,14146.646h-10.006a1.239,1.239,0,0,1-.865-2.117l1.6-1.6v-6.2a8.783,8.783,0,0,1,1.457-5.03,6.841,6.841,0,0,1,4.121-2.8v-.842a1.859,1.859,0,1,1,3.719,0v.842a6.85,6.85,0,0,1,4.119,2.8,8.778,8.778,0,0,1,1.459,5.025v.485a7.175,7.175,0,0,0-5.6,9.43Z",
    transform: "translate(-22843.586 -12574.365)",
    fill: "#cbdaee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "block-microphone",
    d: "M22.906,14.226a5.57,5.57,0,1,0,5.57,5.57A5.576,5.576,0,0,0,22.906,14.226Zm0,1.519a4.024,4.024,0,0,1,2.275.7L19.557,22.07a4.023,4.023,0,0,1-.7-2.274,4.047,4.047,0,0,1,4.051-4.051Zm3.349,1.776a4.047,4.047,0,0,1-5.623,5.623Z",
    transform: "translate(1790.002 1550.126)",
    fill: "#8ba5c9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.78bc1eff.svg";
export { ForwardRef as ReactComponent };